import { gql } from "@apollo/client/core";

export const CHATBOT_CHAT = gql`
    mutation ChatbotChat($message: String!, $threadId: String) {
        chatbot_chat(message: $message, threadId: $threadId) {
            response
            runId
            errorCode
            assets {
                ... on MapAsset {
                    title
                    points {
                        latitude
                        longitude
                        popupText
                    }
                }
                ... on ImageAsset {
                    title
                    base64
                    mime
                }
            }
        }
    }
`;

export const CHATBOT_FEEDBACK = gql`
    mutation ChatbotFeedback($runId: String!, $score: Float, $comment: String) {
        chatbot_feedback(runId: $runId, score: $score, comment: $comment)
    }
`;

export const CHATBOT_ENTITIES = gql`
    query ChatbotEntities {
        chatbot_entities {
            id
            name
            type
        }
    }
`;

export const CHATBOT_RESET_THREAD = gql`
    query ChatbotResetThread {
        chatbot_reset_thread {
            threadId
        }
    }
`;
